/* import __COLOCATED_TEMPLATE__ from './banner-type-dropdown-item.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';

interface ComponentAttrs {
  text: string;
  value: string;
  description: string;
}

interface Args {
  componentAttrs: ComponentAttrs;
}

// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default class BannerTypeDropdownItem extends Component<Args> {}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Articles::Site::Settings::General::BannerTypeDropdownItem': typeof BannerTypeDropdownItem;
    'articles/site/settings/general/banner-type-dropdown-item': typeof BannerTypeDropdownItem;
  }
}
